import {
  Box,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

// ✅ Services list
const serviceRows = [
  {
    id: 1,
    category: "Haircut",
    name: "Classic Haircut",
    description: "A standard haircut with styling.",
    price: 300,
    duration: 30,
  },
  {
    id: 2,
    category: "Shaving",
    name: "Beard Trim",
    description: "Beard trimming and shaping.",
    price: 200,
    duration: 20,
  },
  {
    id: 3,
    category: "Hair Treatment",
    name: "Hair Spa",
    description: "Deep conditioning hair spa treatment.",
    price: 600,
    duration: 45,
  },
];

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ViewServiceProviders = () => {
  const navigate = useNavigate();

  // Main Tabs (Details / Booking / Services)
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  // Sub-tabs inside Booking History (Pending / Upcoming / Completed / Cancelled)
  const [valueBookingTabs, setValueBookingTabs] = useState(0);
  const handleChangeBookingTabs = (
    event: React.SyntheticEvent,
    newValue: number
  ) => {
    setValueBookingTabs(newValue);
  };

  // ✅ Booking Rows
  const [rows] = useState([
    {
      id: "B001",
      serviceDetails: "Hair Color",
      dateTime: "2025-08-22 10:00 AM - 12:00 PM",
      notes: "Bring extra tools",
      customerAddress: "123 Main Street, City",
      providerAddress: "456 Service Lane, City",
      providerDetails: "Hair Razors",
      price: "AED 200",
      type: "In-Home",
      status: "Pending",
      review: "Waiting for service completion",
      rating: "-",
    },
    {
      id: "B002",
      serviceDetails: "Hair Wash",
      dateTime: "2025-08-23 2:00 PM - 4:00 PM",
      notes: "Wash with good shampoo",
      customerAddress: "789 Green Park, City",
      providerAddress: "321 Water Street, City",
      providerDetails: "Salon Elegance",
      price: "AED 300",
      type: "Upcoming",
      status: "Upcoming",
      review: "Not yet started",
      rating: "-",
    },
    {
      id: "B003",
      serviceDetails: "Makeup",
      dateTime: "2025-08-18 3:00 PM - 5:00 PM",
      notes: "Bridal makeup",
      customerAddress: "45 Downtown, City",
      providerAddress: "87 Glam Street, City",
      providerDetails: "Glow Studio",
      price: "AED 1200",
      type: "In-Store",
      status: "Completed",
      review: "Excellent service!",
      rating: "5/5",
    },
    {
      id: "B004",
      serviceDetails: "Spa Therapy",
      dateTime: "2025-08-20 11:00 AM - 1:00 PM",
      notes: "Aroma oils",
      customerAddress: "55 Lakeview, City",
      providerAddress: "22 Relax Ave, City",
      providerDetails: "Wellness Hub",
      price: "AED 500",
      type: "In-Store",
      status: "Cancelled",
      cancelledBy: "Admin",
      cancelledOn: "2025-08-19 05:45 PM",
      cancellationReason: "Service provider unavailable",
      review: "Could not experience service",
      rating: "-",
    },
  ]);

  const columns = [
    { id: "id", label: "Booking ID" },
    { id: "serviceDetails", label: "Service Details" },
    { id: "dateTime", label: "Selected Date & Time Slot" },
    { id: "notes", label: "Notes" },
    { id: "price", label: "Total Price" },
    { id: "customerAddress", label: "Customer Address" },
    { id: "providerAddress", label: "Service Provider Address" },
    { id: "providerDetails", label: "Service Provider Details" },
    { id: "type", label: "Type" },
    { id: "review", label: "Review" },
    { id: "rating", label: "Rating" },
  ];

  return (
    <>
      <div className="main_title">
        <h1>Service Provider Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-service-providers")}>
            Manage Service Providers
          </button>{" "}
          - Service Provider Detail
        </p>
      </div>

      {/* Tabs */}
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Details" {...a11yProps(0)} />
              <Tab label="Booking History" {...a11yProps(1)} />
              <Tab label="Services" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards view_page">
        {/* ✅ Details Tab */}
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img alt="user" src="/static/images/placeholder.png" />
              </figure>
            </div>
            <div className="w_33">
              <h6>Salon / Business Name</h6>
              <p>Glam Beauty Salon</p>
            </div>
            <div className="w_33">
              <h6>Email</h6>
              <p>Glam@yopmail.com</p>
            </div>
            <div className="w_33">
              <h6>Phone Number</h6>
              <p>9418351795</p>
            </div>
            <div className="w_33">
              <h6>Total Bookings</h6>
              <p>245</p>
            </div>
            <div className="w_33">
              <h6>Current Rating</h6>
              <p>4.9 / 5</p>
            </div>
          </div>
        </CustomTabPanel>

        {/* ✅ Booking History Tab with sub-tabs */}
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="cards">
            <Box
              className=" custom_tabs"
              sx={{ width: "100%", marginBottom: 2 }}
            >
              <Tabs
                value={valueBookingTabs}
                onChange={handleChangeBookingTabs}
                aria-label="booking tabs"
                className="custom_tabs_links"
              >
                <Tab label="Pending" {...a11yProps(0)} />
                <Tab label="Upcoming" {...a11yProps(1)} />
                <Tab label="Completed" {...a11yProps(2)} />
                <Tab label="Cancelled" {...a11yProps(3)} />
              </Tabs>
            </Box>

            {/* Render Booking Tables */}
            {["Pending", "Upcoming", "Completed", "Cancelled"].map(
              (status, idx) => (
                <CustomTabPanel key={status} value={valueBookingTabs} index={idx}>
                  <TableContainer className="table_container">
                    <Table>
                      <TableHead>
                        <TableRow>
                          {columns.map((col) => (
                            <TableCell key={col.id}>{col.label}</TableCell>
                          ))}
                          {status === "Cancelled" && (
                            <>
                              <TableCell>Cancelled By</TableCell>
                              <TableCell>Cancelled On</TableCell>
                              <TableCell>Cancellation Reason</TableCell>
                            </>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows
                          .filter((row) => row.status === status)
                          .map((row) => (
                            <TableRow key={row.id}>
                              {columns.map((col) => (
                                <TableCell key={col.id}>
                                  {row[col.id as keyof typeof row]}
                                </TableCell>
                              ))}
                              {status === "Cancelled" && (
                                <>
                                  <TableCell>{row.cancelledBy}</TableCell>
                                  <TableCell>{row.cancelledOn}</TableCell>
                                  <TableCell>{row.cancellationReason}</TableCell>
                                </>
                              )}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CustomTabPanel>
              )
            )}
          </div>
        </CustomTabPanel>

        {/* ✅ Services Tab */}
        <CustomTabPanel value={valueTabs} index={2}>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Service Category</TableCell>
                  <TableCell>Service Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {serviceRows.map((row) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{row.category}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.description}</TableCell>
                    <TableCell>₹{row.price}</TableCell>
                    <TableCell>{row.duration} mins</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>
    </>
  );
};

export default ViewServiceProviders;
